/*
  Busca inteligente do cabecalho (snippets/header-search.liquid).
  1. Atalhos de categoria enquanto a pessoa digita: "capa" mostra Capacetes, "speed" mostra Speed, com a
     quantidade de pecas de cada uma.
  2. Corretor: quando a busca nao acha nada, ou so acha pecas sem relacao com o que foi digitado, corrige o erro
     de digitacao pelo vocabulario da loja ("blisa" vira "blusa", "capcte" vira "capacete") e mostra os resultados
     do termo corrigido, com a opcao de buscar exatamente o que foi digitado. Ao apertar Enter com a correcao na
     tela, a busca completa tambem usa o termo corrigido.
  Dados (termos e categorias) em #unend-busca-dados, gerado por snippets/unend-busca-vocabulario.liquid.
*/
(() => {
  const dadosEl = document.getElementById('unend-busca-dados');
  const busca = document.querySelector('header-search');
  if (!dadosEl || !busca) return;

  let dados;
  try {
    dados = JSON.parse(dadosEl.textContent);
  } catch (erro) {
    return;
  }

  const campo = busca.querySelector('.header-search__input');
  const resultados = busca.querySelector('predictive-search [slot="results"]');
  const formulario = busca.querySelector('form');
  if (!campo || !resultados) return;

  const raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');

  const normalizar = (texto) =>
    (texto || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  /* Vocabulario: palavra sem acento -> palavra como aparece na loja */
  const vocabulario = new Map();
  (dados.termos || []).forEach((termo) => {
    String(termo)
      .split(/[\s/,()&+|-]+/)
      .forEach((palavra) => {
        const original = palavra.trim().toLowerCase();
        const chave = normalizar(original);
        if (chave.length >= 4 && !/\d/.test(chave) && !/\s/.test(chave) && !vocabulario.has(chave)) vocabulario.set(chave, original);
      });
  });

  /* Categorias: "Nome|Grupo|url|quantidade" */
  const categorias = (dados.cats || [])
    .map((linha) => {
      const partes = String(linha).split('|');
      return {
        nome: (partes[0] || '').trim(),
        grupo: (partes[1] || '').trim(),
        url: (partes[2] || '').trim(),
        qtd: Number(partes[3]) || 0,
      };
    })
    .filter((categoria) => categoria.nome && categoria.url && categoria.qtd > 0)
    .filter((categoria, indice, lista) => lista.findIndex((outra) => outra.url === categoria.url) === indice)
    .map((categoria) => ({
      ...categoria,
      palavrasNome: normalizar(categoria.nome).split(' '),
      palavrasGrupo: normalizar(categoria.grupo).split(' '),
    }));

  /* Distancia de edicao (com troca de letras vizinhas), parando cedo quando passa do limite */
  const distancia = (a, b, limite) => {
    if (Math.abs(a.length - b.length) > limite) return limite + 1;
    const tabela = [];
    for (let i = 0; i <= a.length; i++) tabela[i] = [i];
    for (let j = 0; j <= b.length; j++) tabela[0][j] = j;
    for (let i = 1; i <= a.length; i++) {
      let menorDaLinha = Infinity;
      for (let j = 1; j <= b.length; j++) {
        const custo = a[i - 1] === b[j - 1] ? 0 : 1;
        let valor = Math.min(tabela[i - 1][j] + 1, tabela[i][j - 1] + 1, tabela[i - 1][j - 1] + custo);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          valor = Math.min(valor, tabela[i - 2][j - 2] + 1);
        }
        tabela[i][j] = valor;
        if (valor < menorDaLinha) menorDaLinha = valor;
      }
      if (menorDaLinha > limite) return limite + 1;
    }
    return tabela[a.length][b.length];
  };

  const corrigirPalavra = (palavra) => {
    if (palavra.length < 4 || /\d/.test(palavra) || vocabulario.has(palavra)) return null;
    for (const chave of vocabulario.keys()) {
      if (chave.startsWith(palavra)) return null; /* ainda digitando uma palavra conhecida */
    }
    const limite = palavra.length <= 5 ? 1 : 2;
    let melhor = null;
    let melhorDistancia = limite + 1;
    vocabulario.forEach((original, chave) => {
      const d = distancia(palavra, chave, limite);
      const desempate = d === melhorDistancia && melhor && chave[0] === palavra[0] && melhor.chave[0] !== palavra[0];
      if (d < melhorDistancia || desempate) {
        melhor = { chave, original };
        melhorDistancia = d;
      }
    });
    return melhor && melhorDistancia <= limite ? melhor : null;
  };

  const corrigirTermo = (termo) => {
    let mudou = false;
    const palavras = normalizar(termo)
      .split(' ')
      .filter(Boolean)
      .map((palavra) => {
        const correcao = corrigirPalavra(palavra);
        if (correcao) {
          mudou = true;
          return correcao.original;
        }
        return palavra;
      });
    return mudou ? palavras.join(' ') : null;
  };

  /* Resultado fraco: nada encontrado, ou alguma palavra digitada nao aparece em nenhuma peca listada */
  const resultadoFraco = (termo) => {
    if (resultados.querySelector('.predictive-search__no-results')) return true;
    const produtos = resultados.querySelector('.predictive-search__products');
    if (!produtos) return true;
    const palavrasResultado = normalizar(produtos.textContent).split(' ');
    const digitadas = normalizar(termo)
      .split(' ')
      .filter((palavra) => palavra.length >= 4 && !/\d/.test(palavra));
    return digitadas.some(
      (palavra) =>
        !palavrasResultado.some(
          (encontrada) => encontrada.startsWith(palavra) || (encontrada.length >= 4 && palavra.startsWith(encontrada))
        )
    );
  };

  const ehNosso = (no) =>
    no.nodeType === 1 && (no.classList.contains('unend-busca-atalhos') || no.classList.contains('unend-busca-correcao'));

  /* Atalhos de categoria */
  const atualizarAtalhos = (termo) => {
    resultados.querySelectorAll('.unend-busca-atalhos').forEach((no) => no.remove());
    const palavras = normalizar(termo)
      .split(' ')
      .filter((palavra) => palavra.length >= 3);
    if (!palavras.length) return;

    const encontradas = categorias
      .map((categoria) => {
        let pontos = 0;
        for (const palavra of palavras) {
          const noNome = categoria.palavrasNome.some(
            (w) => w.startsWith(palavra) || (palavra.length >= 5 && distancia(palavra, w.slice(0, palavra.length + 1), 1) <= 1)
          );
          if (noNome) pontos += 2;
          else if (categoria.palavrasGrupo.some((w) => w.startsWith(palavra))) pontos += 1;
          else return null;
        }
        return { categoria, pontos };
      })
      .filter(Boolean)
      .sort((a, b) => b.pontos - a.pontos || b.categoria.qtd - a.categoria.qtd)
      .slice(0, 4);

    if (!encontradas.length) return;

    const bloco = document.createElement('div');
    bloco.className = 'unend-busca-atalhos';
    const titulo = document.createElement('p');
    titulo.className = 'unend-busca-atalhos__titulo';
    titulo.textContent = en ? 'Categories' : 'Categorias';
    const lista = document.createElement('div');
    lista.className = 'unend-busca-atalhos__lista';

    encontradas.forEach(({ categoria }) => {
      const link = document.createElement('a');
      link.className = 'unend-busca-atalhos__item';
      link.href = categoria.url;
      const nome = document.createElement('span');
      nome.textContent = categoria.nome;
      link.append(nome);
      if (categoria.grupo && normalizar(categoria.grupo) !== normalizar(categoria.nome)) {
        const grupo = document.createElement('span');
        grupo.className = 'unend-busca-atalhos__grupo';
        grupo.textContent = categoria.grupo;
        link.append(grupo);
      }
      lista.append(link);
    });

    bloco.append(titulo, lista);
    const aviso = resultados.querySelector('.unend-busca-correcao');
    if (aviso) aviso.after(bloco);
    else resultados.prepend(bloco);
  };

  const avisoCorrecao = (original, corrigido) => {
    const aviso = document.createElement('p');
    aviso.className = 'unend-busca-correcao';
    aviso.append(en ? 'Showing results for ' : 'Mostrando resultados para ');
    const forte = document.createElement('strong');
    forte.textContent = corrigido;
    aviso.append(forte, '. ');
    const link = document.createElement('a');
    link.href = `${raiz}search?q=${encodeURIComponent(original)}`;
    link.textContent = en ? `Search for "${original}"` : `Buscar por "${original}"`;
    aviso.append(link);
    return aviso;
  };

  let correcaoAtiva = null;
  let ultimoPedido = 0;

  const buscarCorrigido = async (original, corrigido) => {
    const pedido = ++ultimoPedido;
    const url = `${raiz}search/suggest?q=${encodeURIComponent(corrigido)}&section_id=predictive-search&resources[limit]=10&resources[limit_scope]=each`;
    try {
      const html = await (await fetch(url)).text();
      if (pedido !== ultimoPedido || campo.value.trim() !== original) return;
      const documento = new DOMParser().parseFromString(html, 'text/html');
      const secao = documento.querySelector('.shopify-section');
      if (!secao || secao.querySelector('.predictive-search__no-results')) return;
      correcaoAtiva = { original, corrigido };
      resultados.replaceChildren(...document.importNode(secao, true).children);
      resultados.prepend(avisoCorrecao(original, corrigido));
      atualizarAtalhos(corrigido);
    } catch (erro) {
      /* sem correcao: ficam os resultados normais */
    }
  };

  const aoMudarResultados = () => {
    const termo = campo.value.trim();
    if (!termo) return;
    if (correcaoAtiva && correcaoAtiva.original === termo && resultados.querySelector('.unend-busca-correcao')) return;
    correcaoAtiva = null;
    atualizarAtalhos(termo);
    if (!resultadoFraco(termo)) return;
    const corrigido = corrigirTermo(termo);
    if (corrigido && normalizar(corrigido) !== normalizar(termo)) buscarCorrigido(termo, corrigido);
  };

  new MutationObserver((registros) => {
    const externo = registros.some((registro) =>
      [...registro.addedNodes, ...registro.removedNodes].some(
        (no) => !ehNosso(no) && !(no.nodeType === 3 && !no.textContent.trim())
      )
    );
    if (externo) aoMudarResultados();
  }).observe(resultados, { childList: true });

  if (formulario) {
    formulario.addEventListener(
      'submit',
      () => {
        const termo = campo.value.trim();
        if (correcaoAtiva && correcaoAtiva.original === termo) campo.value = correcaoAtiva.corrigido;
      },
      true
    );
  }
})();
